import { useUserAuth } from "../../hooks/UserAuthContext";
import { useNavigate } from "react-router-dom";

export function LeaveScreen({ setIsMeetingLeft }) {
  const { logOut } = useUserAuth();
  const navigate = useNavigate();
  return (
    <div className="bg-white h-screen flex flex-col flex-1 items-center justify-center">
      <div className="text-center max-w-md mx-auto px-6">
        <div className="mb-8">
          <div className="w-20 h-20 bg-violet-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
          <h1 className="text-violet-700 text-4xl font-bold mb-4">You left the meeting!</h1>
          <p className="text-violet-500 text-lg">Thank you for joining. Hope to see you again soon.</p>
        </div>
        
        <div className="mt-12">
          <button
            className="w-full bg-violet-600 hover:bg-violet-700 text-white px-16 py-4 rounded-lg text-lg font-medium transition-colors duration-150 shadow-lg"
            onClick={async () => {
              try {
                await logOut();
                navigate('/login');
              } catch (error) {
                console.error('Logout failed:', error);
                // Still navigate to login even if logout fails
                navigate('/login');
              }
            }}
          >
            Return to Login
          </button>
        </div>
      </div>
    </div>
  );
}
